package scenes

import AppIntegrations
import AppState
import com.soywiz.korge.input.*
import com.soywiz.korge.scene.*
import com.soywiz.korge.ui.*
import com.soywiz.korge.view.*
import com.soywiz.korim.bitmap.*
import com.soywiz.korim.color.*
import com.soywiz.korim.font.*
import com.soywiz.korim.format.*
import com.soywiz.korim.text.*
import com.soywiz.korio.file.std.*
import com.soywiz.korma.geom.*
import i18n.*
import scenes.test.*
import ui.*
import utils.*

class MainMenuScene : Scene() {

    private var buttonFont: Font? = null
    private var logo: Bitmap? = null
    private var startButtonIcon: Bitmap? = null
    private var startButtonIconActive: Bitmap? = null

    override suspend fun SContainer.sceneInit() {
        container {
            loadBackground()
        }

        logo = resourcesVfs["logo.png"].readBitmap()
        startButtonIcon = resourcesVfs["lobby_buttons/start.png"].readBitmap()
        startButtonIconActive = resourcesVfs["lobby_buttons/start_pressed.png"].readBitmap()
        buttonFont = FontsLoader.loadFont(FontsLoader.GOGONO_COCOA_MOCHI_CYRILLIC)
    }

    override suspend fun SContainer.sceneMain() {

        logo?.let {
            val slice = it.slice()
            image(slice) {
                CustomButton.fitImageInRect(this, slice,
                    width = 481.0,
                    height = 200.0,
                    Anchor.CENTER
                )
                position(
                    GameDimensions.V_WIDTH / 2.0,
                        64.0 + 100.0
                )
            }
        }

        val startButton = startButton()

        versionText()

        AppIntegrations.yaSdk?.adv?.showFullscreenAdv()
    }

    private suspend fun Container.loadBackground() {
        val dir = "background/forest"
        val bgBitmap = resourcesVfs["$dir/01.png"].readBitmap()
        val clouds1 = resourcesVfs["$dir/02.png"].readBitmap()
        val clouds2 = resourcesVfs["$dir/03.png"].readBitmap()
        val clouds3 = resourcesVfs["$dir/04.png"].readBitmap()

        parallax(bgBitmap, clouds1, clouds2, clouds3)
    }

    private fun Container.startButton(): CustomButton {
        val width = 258.5
        val height = 82.5
        val button = CustomButton(
            label = Localization.strings.scene.main.startButton,
            width = width,
            height = height,
            icon = startButtonIcon?.slice(),
            activeIcon = startButtonIconActive?.slice(),
            buttonId = -1
        )
        button.container.addTo(this)
        button.container.position(
            GameDimensions.V_WIDTH / 2.0 - width / 2.0,
            64.0 + 200.0 + 90.0
        )
        button.text.apply {
            textSize = 36.0
            textColor = Colors.WHITE
            textFont = buttonFont ?: DefaultUIFont
        }

        button.container.onClick {
            sceneContainer.changeTo<LobbyScene>()
        }

        return button
    }

    // Box2dScene
    private fun Container.testScene(): UIButton {
        val width = GameDimensions.V_WIDTH / 5.0
        return uiButton(
            label = "Тест",
            width = width,
            height = 32.0
        ) {
            position(
                GameDimensions.V_WIDTH / 2.0 - width / 2.0,
                (GameDimensions.V_HEIGHT / 6.0) * 5
            )
            onClick {
                sceneContainer.changeTo<Box2dScene>()
            }
            alpha = 0.8
        }
    }

    private fun Container.infoText() = uiText(
        text = "",
        width = GameDimensions.V_WIDTH / 2.0,
        height = 18.0
    ) {
        position(
            GameDimensions.V_WIDTH / 4.0,
            (GameDimensions.V_HEIGHT / 10.0) * 5
        )

        textAlignment = TextAlignment.CENTER
    }

    private fun Container.versionText() = uiText(
        text = "v ${Constants.VERSION}",
        width = 128.0,
        height = 9.0
    ) {
        position(
            8,
            GameDimensions.V_HEIGHT - 8 - 9
        )

        textSize = 8.0
    }
}
